var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRolePlusButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6232_60139)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6232_60139)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 17,
    height: 17,
    rx: 8.5,
    fill: "#102A62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.048 10.3147V11.2776H11.0125V14.2478H9.98433V11.2776H6.94881V10.3147H9.98433V7.32816H11.0125V10.3147H14.048Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6232_60139",
    x: 0.64,
    y: 0.98,
    width: 19.72,
    height: 19.72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.34
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.68
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6232_60139"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6232_60139",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6232_60139"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 17,
    height: 17,
    rx: 8.5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRolePlusButton);
export default __webpack_public_path__ + "static/media/RolePlusButton.f27e03a5f8964fa7f935fa1eb1770129.svg";
export { ForwardRef as ReactComponent };